/**
 * Postcode Synchronization
 * Keeps header postcode validator and delivery widget in sync
 */

document.addEventListener('DOMContentLoaded', function() {
  enhancePostcodeValidator();
  startPostcodePolling();
});

function enhancePostcodeValidator() {
  // Find the postcode form
  const postcodeForm = document.getElementById('postcode-form');
  if (!postcodeForm) {
    console.log('Postcode sync - No postcode form found');
    return;
  }

  // Override the form submission to dispatch events
  postcodeForm.addEventListener('submit', async function(event) {
    const postcodeInput = document.getElementById('postcode-input');
    const postcode = postcodeInput?.value?.trim();
    
    if (postcode) {
      // Wait a bit for the original validation to complete
      setTimeout(() => {
        // Check if postcode was successfully saved (indicates validation passed)
        const savedPostcode = localStorage.getItem('validated_postcode');
        if (savedPostcode === postcode) {
          console.log('Postcode sync - Dispatching validation event:', postcode);
          
          // Dispatch custom event for delivery widget
          window.dispatchEvent(new CustomEvent('postcodeValidated', {
            detail: { postcode: postcode }
          }));
        }
      }, 500); // Wait 500ms for validation to complete
    }
  });

  console.log('Postcode sync - Enhanced header postcode validator');
}

// Also monitor for direct localStorage changes
let lastPostcode = localStorage.getItem('validated_postcode');

function startPostcodePolling() {
  setInterval(() => {
    const currentPostcode = localStorage.getItem('validated_postcode');
    if (currentPostcode !== lastPostcode) {
      console.log('Postcode sync - Postcode changed via localStorage:', currentPostcode);
      lastPostcode = currentPostcode;
      
      // Dispatch event for delivery widget
      window.dispatchEvent(new CustomEvent('postcodeValidated', {
        detail: { postcode: currentPostcode }
      }));
    }
  }, 500); // Check every 500ms
}
